import { computed, ref } from 'vue'

import {
  FilePrivacy,
  UserPermission,
  useUpdateAccountDefaultFilePrivacyMutation,
  type User,
} from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'

export function useDefaultFilePrivacy(user: User) {
  const toastStore = useToastStore()

  const { mutate: updateDefaultFilePrivacy, loading } =
    useUpdateAccountDefaultFilePrivacyMutation()

  const isBasic = computed(() => !user.permissions.includes(UserPermission.Pro))

  const isPrivate = ref(user.defaultFilePrivacy === FilePrivacy.Private)

  const save = async () => {
    if (isBasic.value) return false

    try {
      await updateDefaultFilePrivacy(
        { isPrivate: isPrivate.value },
        {
          optimisticResponse: {
            __typename: 'Mutation',
            updateAccountDefaultFilePrivacy: {
              __typename: 'User',
              id: user.id,
              defaultFilePrivacy: isPrivate.value
                ? FilePrivacy.Private
                : FilePrivacy.Public,
            },
          },
        }
      )

      toastStore.showToast({
        type: ToastType.Success,
        content: 'Default file privacy updated successfully',
      })

      return true
    } catch {
      toastStore.showToast({
        type: ToastType.Error,
        content: 'Could not update default file privacy',
      })

      return false
    }
  }

  return { isPrivate, isBasic, loading, save }
}
